module.exports = __webpack_public_path__ + "media/images/logos/Malaysia-Kini_logo-a48483b8985137416aaf7674e6d95b55.svg";